/**
 * getErrorStatus function
 * Extracts an HTTP status code from an error of unknown shape, covering both a status
 * set directly on the error and the nested response.status that Axios errors carry.
 *
 * @param error - The caught error, of unknown shape
 * @returns The status code if the error carries one, otherwise undefined
 */
export const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== "object" || error === null) return undefined;

  const { status, response } = error as { status?: unknown; response?: { status?: unknown } };

  if (typeof status === "number") return status;
  if (typeof response?.status === "number") return response.status;

  return undefined;
};
